import { PTPStatus, PTPStatusConfig } from "@portal/types/entities/ptp";

const ptpStatusConfig: PTPStatusConfig = {
  OPEN: {
    label: "Open",
    style: {
      borderColor: "var(--red-1)",
      backgroundColor: "var(--red-1)",
      textColor: "var(--red-6)",
    },
  },

  CLOSED: {
    label: "Closed",
    style: {
      borderColor: "var(--green-1)",
      backgroundColor: "var(--green-1)",
      textColor: "var(--green-6)",
    },
  },
};

export function getPTPStatusConfig(status: PTPStatus) {
  return ptpStatusConfig[status];
}
